<li
    *ngIf="visible && !message.sticky"
    @animationState
    (@animationState.done)="dismissMessage()"
    class="agpr-growl"
    [ngClass]="'agpr-growl--' + messageSeverityEnum[message.severity]"
    role="alert"
>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</li>

<li
    *ngIf="visible && message.sticky"
    #growl
    [@stickyAnimation]="visible ? 'visible' : 'hidden'"
    class="agpr-growl"
    [ngClass]="'agpr-growl--' + messageSeverityEnum[message.severity]"
    role="alert"
    tabindex="0"
>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</li>

<ng-template #content>
    <i
        class="agpr-growl-icon"
        [ngClass]="iconMap[message.severity]"
    ></i>
    <div
        class="agpr-growl-content"
    >
        <div
            class="agpr-growl-summary"
            *ngIf="message.summary"
        >
            {{ message.summary | localize }}
        </div>
        <div
            class="agpr-growl-detail"
        >
            {{ message.detail | localize }}
        </div>
        <div
            *ngIf="message?.data?.html"
            [innerHTML]="message.data.html | sanitizeHtml"
        ></div>
    </div>
    <button
        class="agpr-growl-closeIcon agpr-i-close"
        [id]="id + '.closeIcon'"
        (click)="dismissMessage()"
        [attr.aria-label]="'dismissMessage' | localize"
    >
    </button>
</ng-template>
